import { Tooltip, useMantineTheme } from '@mantine/core';
import { IconTopologyStar } from '@tabler/icons-react';

const LABELS: Record<string, string> = {
  parent: 'Nadradené zariadenie',
};

const ICONS: Record<string, typeof IconTopologyStar> = {
  parent: IconTopologyStar,
};

/**
 * Icon component for displaying the structure of a device.
 */
export default function DeviceStructureIcon({ structure: deviceStructure }: { structure: string }) {
  const theme = useMantineTheme();

  const label = LABELS[deviceStructure];
  const Icon = ICONS[deviceStructure];

  if (label && Icon) {
    return (
      <Tooltip withinPortal label={label} position="top" openDelay={200}>
        <Icon size={20} stroke={1.5} color={theme.colors.red[7]} />
      </Tooltip>
    );
  }

  return null;
}
